import "./SecurityLinkComponents.scss";
import template from "./SecurityLinkComponents.html";
import {IComponentOptions, IRootElementService} from "angular";
import {CodeAndExchange, encodeSecurity} from "../../../instruments/types/CodeAndExchange";
import {AsxIndexUtil} from "../../../js/util/asx/AsxIndexUtil";
import {FeatureNames} from "../../../types/UserConfig";
import {CurrentUser} from "../../../services/user/models/CurrentUser";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {Observable, ReplaySubject} from "rxjs";
import {isNotNull} from "../../../js/util/UtilFunctions";
import {StateService} from "@uirouter/core";

export const SecurityLink = "tfSecurityLink";

export function securityLink(): IComponentOptions {
    return {
        template,
        bindings: {
            security: "<",
            isClickTarget: "<"
        },
        controllerAs: "ctrl",
        controller: SecurityLinkComponentsController
    };
}

export class SecurityLinkComponentsController {

    /** @input */
    public set security(security: CodeAndExchange | null) {
        if (security != null) {
            this.security$.next(security);
        }
    }

    private readonly security$ = new ReplaySubject<CodeAndExchange>(1);

    public readonly display$: Observable<string>;
    public readonly link$: Observable<string | null>;
    public readonly hasLink$: Observable<boolean>;

    /** @input */
    public readonly isClickTarget: boolean;

    /** @ngInject */
    public constructor(private readonly $element: IRootElementService,
                       private readonly currentUserService: CurrentUserService,
                       private readonly $state: StateService) {
        this.display$ = this.security$.map((s) => s.code);
        this.link$ = this.buildLink();
        this.hasLink$ = this.link$.map(isNotNull);
    }

    private buildLink(): Observable<string | null> {
        const source$ = Observable.combineLatest(this.security$, this.currentUserService.current);
        return source$.map(([security, user]) => this.calculateLink(security, user))
                      .publishReplay(1)
                      .refCount();
    }

    private calculateLink(security: CodeAndExchange, user: CurrentUser): string | null {
        if (!AsxIndexUtil.isIndex(security.code) && user.hasFeature(FeatureNames.SCREEN_COMPANY_INFO)) {
            const encoded = encodeSecurity(security);
            return this.$state.href("company-info", {security: encoded});
        } else if (user.hasFeature(FeatureNames.FEATURE_ADV_CHARTING)) {
            return this.$state.href("charting", {symbol: security.code});
        } else if (user.hasFeature(FeatureNames.SCREEN_STRATEGY_BUILDER)) {
            return this.$state.href("strategy", {underlying: security.code});
        } else {
            return null;
        }
    }
}
